import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNaviconProjects = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M17.964 7V17.5417M17.964 17.5417L27.8319 23.5M17.964 17.5417L7.91699 23.5",
		stroke: "#1D1D1D",
		strokeWidth: .916667
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.91699 12.28L18.0003 7L28.0837 12.28M7.91699 12.28L18.0003 17.78M7.91699 12.28V23.5L18.0003 29M28.0837 12.28L18.0003 17.78M28.0837 12.28V23.72L18.0003 29M18.0003 17.78V29",
		stroke: "#1D1D1D",
		strokeWidth: .916667
	})]
});
export default SvgNaviconProjects;
